// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"23b65eb5","237":"88efc13e","390":"46fc43d1","463":"c29912a5","555":"f6cdb5bf","600":"c8db30b0","950":"c3457354"}[chunkId] + ".chunk.js";
};